
import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { State } from 'vuex-class';
import {
  Form,
  FormItem,
  Input,
  Cascader,
  Select,
  Option,
} from 'element-ui';
import QuesApi from '@/api/question';
import api from '@/api/asset';
import Util from '@/libs/util';
import apis from '@/api/exam';
import app from '@/api/app';
import { COMMON_DATA_TYPE } from '@/libs/config';

@Component({
  components: {
    Form,
    FormItem,
    Input,
    Cascader,
    Select,
    Option,
  },
})
export default class SearchForm extends Vue {
  private form: any = {
    serial: '',
    status: '0',
  };

  public $refs!: {
    form: Form,
  };

  setTitle(val: string) {
    this.form.serial = val;
  }

  getFormData() {
    return this.form;
  }

  /**
   * @desc 清空事件
   */
  handleClear() {
    this.$refs.form.resetFields();
    this.form.status = '0';
  }
}
